import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import filteredObjectsSelector from 'functions/filteredObjectsSelector'
import { objectsToArray, sortArrayBy } from 'functions/utilities'

import * as campaignProposalSectionActions from 'agency/redux/modules/campaignProposalSection'

const sortSections = (campaignProposalSections) => {
  const array = objectsToArray(campaignProposalSections)
  return sortArrayBy(array, 'asc', 'sort')
}

class ProposalSectionsWrapper extends React.Component {
  _createSection = () => {
    const { campaignProposal, createCampaignProposalSection } = this.props

    const section = {
      campaign_proposal_id: campaignProposal.id,
      title: 'New Section',
    }

    createCampaignProposalSection(section)
  }

  render(){
    const { campaignProposalSections, creatingSection, render } = this.props

    const sortedSections = sortSections(campaignProposalSections)

    return render({
      createSection: this._createSection,
      creatingSection,
      sections: sortedSections,
    })
  }
}

ProposalSectionsWrapper.propTypes = {
  campaignProposal: PropTypes.object.isRequired,
  campaignProposalSections: PropTypes.object.isRequired,
  createCampaignProposalSection: PropTypes.func.isRequired,
  creatingSection: PropTypes.bool,
  render: PropTypes.func.isRequired,
}

function mapStateToProps(state, props){
  const { campaignProposal } = props

  return {
    campaignProposalSections: filteredObjectsSelector(
      state,
      'campaignProposalSections',
      'campaign_proposal_id',
      campaignProposal.id,
    ),
    creatingSection: state.campaignProposalSections.creating,
  }
}

const mapDispatchToProps = {
  createCampaignProposalSection: campaignProposalSectionActions.createCampaignProposalSection,
}

export default connect(mapStateToProps, mapDispatchToProps)(ProposalSectionsWrapper)
